(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-menu-subnav"] && !Shopify.designMode) return;
  try {
    function initAccordions() {
		const accordions = document.querySelectorAll('[data-accordion]');

		if (!accordions.length) return;

		accordions.forEach((accordion) => {
			const toggle = accordion.querySelector('[data-accordion-toggle]');
			const contentWrap = accordion.querySelector(
				'[data-accordion-content]',
			);

			if (!toggle) {
				console.warning('Accordion is missing a toggle!');
				return;
			}

			if (!contentWrap) {
				console.warning('Accordion is missing a content wrapper');
			}

			toggle.addEventListener('click', () => {
				const accordionState = accordion.getAttribute(
					'data-accordion-state',
				);
				accordions.forEach((accordion) =>
					accordion.setAttribute('data-accordion-state', 'closed'),
				);

				if (accordionState === 'closed') {
					accordion.setAttribute('data-accordion-state', 'open');
					return;
				}

				accordion.setAttribute('data-accordion-state', 'closed');
			});
		});
	}

	function initBannerSwipers() {
		const swipers = document.querySelectorAll('[data-subnav-swiper]');

		if (!swipers.length) return;

		swipers.forEach((swiper) => {
			new Swiper(swiper, {
			autoplay: {
				delay: 5000
			},
				loop: true,
			});
		});
	}

	document.addEventListener('DOMContentLoaded', () => {
		initAccordions();
		initBannerSwipers();
	});
  } catch(e) { console.error(e); }
})();

})();
